import { observable } from '@legendapp/state';

interface InteriorStore {
	interiorContainer: HTMLDivElement;
	isInteriorLoaded: boolean;
	isInteriorLoading: boolean;
	currentInterior: [string, string];
	isDragging: boolean;
	isHidden: boolean;
}

const createDefaultInteriorContainer = (): HTMLDivElement =>
	typeof document !== 'undefined' ? document.createElement('div') : ({} as HTMLDivElement);

export const interiorStore = observable<InteriorStore>({
	interiorContainer: createDefaultInteriorContainer(),
	isInteriorLoaded: false,
	isInteriorLoading: false,
	currentInterior: ['', ''],
	isDragging: false,
	isHidden: (): boolean => interiorStore.isDragging.get() || interiorStore.isInteriorLoading.get()
});

export const interiorStoreActions = {
	setIsInteriorLoaded: (bool: boolean) => {
		interiorStore.isInteriorLoaded.set(bool);
	},
	setIsInteriorLoading: (bool: boolean) => {
		interiorStore.isInteriorLoading.set(bool);
	},
	setInteriorData: (data: [string, string]) => {
		interiorStore.currentInterior.set(data);
	}
};
